import { MapDispatchToPropsFunction, connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import UploadProject from 'components/ModalWindows/UploadProject';
import { UploadProjectDispatchProps, UploadProjectOwnProps, UploadProjectSelectors } from 'components/ModalWindows/UploadProject/models';
import { ModalType } from 'const';
import { hasBothMobileAndDesktopViews } from 'containers/Common/selectors';
import { countryAbbreviations } from 'containers/CountryAbbreviations/selectors';
import { createBinderDuplicate, hideModal, showModal } from 'containers/ModalManager/actions';
import { modalWindowOptions } from 'containers/ModalManager/selectors';
import { uploadToPromoMats } from 'containers/Project/actions';
import { isProjectTranslatable, projectType } from 'containers/Project/selectors';
import { rootDocumentId, targetCountry } from 'containers/RootDocument/selectors';
import { UploadContextOptions } from 'models';

const mapStateToProps: (
  props: UploadProjectOwnProps
) => ReturnType<typeof createStructuredSelector> = (
  props: UploadProjectOwnProps,
) => createStructuredSelector({
  options: modalWindowOptions(props.modalWindowId),
  isProjectTranslatable,
  projectType,
  rootDocumentId,
  hasBothMobileAndDesktopViews,
  targetCountry,
  countryAbbreviations,
});

const mapDispatchToProps: MapDispatchToPropsFunction<
UploadProjectDispatchProps,
UploadProjectOwnProps
> = (dispatch, props) => ({
  hideModal: () => dispatch(hideModal(props.modalWindowId)),
  showBinderModal: payload => dispatch(showModal(ModalType.MANAGE_BINDER, payload)),
  uploadToPromoMats: (uploadProjectType, translationComplete, binderForm, pdfPageOrder) =>
    dispatch(uploadToPromoMats(uploadProjectType, translationComplete, binderForm, pdfPageOrder)),
  createBinderDuplicate: (uploadContext: UploadContextOptions): void => {
    dispatch(createBinderDuplicate(uploadContext));
  },
});

export default connect<UploadProjectSelectors, UploadProjectDispatchProps, UploadProjectOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(UploadProject);
